module.exports = new Promise(async (resolve, reject) => {
                    const findActiveRemove = async url => {
                      try {
                        const { ok } = await fetch(url, {method: 'HEAD'});
                        if(!ok) throw new Error('Branch script not found');
                      } catch(e) {
                        return false
                      }
                      return true;
                    }
                    const localUrl = "http://localhost:4201/remoteEntry.js";
                    const url = "https://lendicdn.net/a2ec9a6b64ca66942365597f8a164740/71ccb7a35a452ea8153b6d920f9f190e/remoteEntry.js";
                    if(await findActiveRemove(localUrl)) return resolve(import(localUrl));
                    if(await findActiveRemove(url)) return resolve(import(url));
                    return reject(new Error("Could not find valid remote for engagement!"));
                  });